import React from 'react';
import { Link } from 'react-router-dom';

import { Page, Button, AddIcon } from '@occc-app/design-system';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { SurveyTableContainer } from './SurveyTableContainer';

import { messages } from '../messages';
import { routeCreator } from '../routeCreator';

export const SurveyListPage: React.FC = () => {
  const isUserPermittedToCreateSurvey = useIsUserPermittedTo(Feature.SURVEY_CREATE);

  const actions = isUserPermittedToCreateSurvey && (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      to={routeCreator.create()}
      startIcon={<AddIcon />}
      role='button'
    >
      new survey
    </Button>
  );

  return (
    <Page
      browserTabTitle={messages.title}
      actions={actions}
      pageHeaderProps={{ title: messages.title }}
    >
      <SurveyTableContainer />
    </Page>
  );
};
